<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.service'> {{$t('txt.serviciu')}}: {{this.service.name}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update service'])">
                <router-link v-if='this.service' :to="{ name: 'editservice', params: { id: service.id }}">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i v-bind:class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import ServicesService from '../../api-services/services.service.js'

export default {
  name: 'viewsubtype',
  data () {
    return {
      service: null
    }
  },
  methods: {
    getService () {
      ServicesService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.service = response.data.data
          this.getCategories()
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.service) ? this.service.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'standard_price',
            labelName: this.$t('placeholder.pretStandard'),
            inputValue: (this.service) ? this.service.standard_price : null,
            icon: 'fas fa-donate'

          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.service) ? this.service.discount : null,
            icon: 'fas fa-money-bill-wave info-tool'
          },
          {
            inputName: 'final_price',
            labelName: this.$t('placeholder.pretFinal'),
            inputValue: (this.service) ? this.service.final_price : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'cost_acquisition',
            labelName: this.$t('placeholder.costAchizitie'),
            inputValue: (this.service) ? this.service.cost_acquisition : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'addition',
            labelName: this.$t('placeholder.adaosComercial'),
            inputValue: (this.service) ? this.service.addition : null,
            icon: 'fas fa-donate'

          },
          {
            inputName: 'max_discount',
            labelName: this.$t('placeholder.discountMaxim'),
            inputValue: (this.service) ? this.service.max_discount : null,
            icon: 'fas fa-money-bill-wave info-tool'

          }
        ]
      }
    }
  },
  mounted () {
    this.getService()
  }
}
</script>
